document.addEventListener("DOMContentLoaded", function(event) { 
  var treeSpan = document.getElementsByClassName('trees_count');
  
    if(treeSpan.length > 0) {
    var xhttp = new XMLHttpRequest();
      
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
         var response = xhttp.responseText;
         var respTrimmed = response.substring(1, response.length-1);
         var respArray = respTrimmed.split(":");
         var respVal = respArray[1];
        
        for (var i = 0; i < treeSpan.length; i++) {
           treeSpan.item(i).innerHTML = respVal;
        }
      }
    };
    xhttp.open("GET", "https://public.ecologi.com/users/estogloballimited/trees", true);
    xhttp.send(); 
    }
  });